module.exports = __webpack_public_path__ + "media/800-2_SERF_2022_EmailRedFlags.a7587152.mp4";